import { lazy } from "react";

import Suspense from "components/shared/Suspense";
import useMount from "hooks/useMount";
import useCurrentUserId from "hooks/user/useCurrentUserId";

const UserMatchPercentageForUser = lazy(
  () => import("./UserMatchPercentageForUser"),
);

export interface Props {
  userId: number;
  size?: "sm" | "md" | "lg";
}

export default function UserMatchPercentage({ userId, size = "sm" }: Props) {
  const currentUserId = useCurrentUserId();
  const mount = useMount();

  if (!mount || !currentUserId) {
    return <></>;
  }
  return (
    <Suspense>
      <UserMatchPercentageForUser
        userId={userId}
        currentUserId={currentUserId}
        size={size}
      />
    </Suspense>
  );
}
